module.exports = "/wp-content/plugins/farmacy/assets/js/images/btn-minus-98429200ae8e6e9a956c0fcb0fa255bc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/cart-review/cart-item-count-incrementor/img/btn-minus.png
 ** module id = 315
 ** module chunks = 1 9 15 67 79 145
 **/